/* @flow */
import React, { memo, Suspense, useMemo } from 'react';
import { Button, Card, PageHeader, Spin, Typography } from 'antd';
import { formatNumberToLocale } from '@/utils/common';
import styles from './ProspectNow.module.pcss';
import { Link } from 'react-router-dom';

const EnrichmentsTable = React.lazy(() => import('@/components/StandardTable'));

type Props = {
  location: {
    state: Object,
  },
  history: {
    goBack: Function,
  },
};

const ProspectNowUploadDetails = ({ location, history }) => {
  const tableData = useMemo(() => {
    return location.state.data?.map((property, i) => ({
      key: i,
      address: property.address || 'N/A',
      ownerType: property.owner_type || 'N/A',
      buildingSize: property.building_size
        ? formatNumberToLocale({
            number: property.building_size,
            style: 'decimal',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })
        : 'N/A',
      propertyUse: property.property_use || 'N/A',
      totalAssessedValue: property.total_assessed_value
        ? formatNumberToLocale({
            number: property.total_assessed_value,
            style: 'decimal',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })
        : 'N/A',
    }));
  }, [location.state.data]);

  const paginationProps = {
    total: tableData?.length,
    current: 1,
    defaultPageSize: 10,
    pageSizeOptions: ['10', '20', '50'],
    showSizeChanger: true,
    showQuickJumper: true,
  };

  const columns = [
    {
      title: 'Address (Address, City, State, ZIP)',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Owner Type',
      dataIndex: 'ownerType',
      key: 'ownerType',
    },
    {
      title: 'Property Use',
      dataIndex: 'propertyUse',
      key: 'propertyUse',
    },
    {
      title: 'Building Size',
      dataIndex: 'buildingSize',
      key: 'buildingSize',
    },
    {
      title: 'Total Assessed Value',
      dataIndex: 'totalAssessedValue',
      key: 'totalAssessedValue',
    },
    {
      title: 'Action',
      key: 'action',
      width: 150,
      render: (data) => (
        <Button type="primary">
          <Link
            to={{
              pathname: '/manage/intake-form',
              state: {
                address: data.address,
              },
            }}
          >
            New Lead
          </Link>
        </Button>
      ),
    },
  ];

  const renderTitle = () => {
    return <Typography.Text strong>Enriched Properties</Typography.Text>;
  };

  return (
    <div>
      <PageHeader
        title={<Typography.Title level={4}>Upload Details</Typography.Title>}
        onBack={() => history.goBack()}
        className={styles.header}
        ghost={false}
      />
      <Suspense fallback={<Spin size="large" />}>
        <Card bordered={false}>
          <EnrichmentsTable title={renderTitle} pagination={paginationProps} columns={columns} data={tableData} />
        </Card>
      </Suspense>
    </div>
  );
};

const ProspectNowUploadDetailsMemo = memo<Props>(ProspectNowUploadDetails);

export default ProspectNowUploadDetailsMemo;
